export default {"src":"/_next/static/media/wallet.f5c94b0c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};